import React from 'react';
import {Box} from "@material-ui/core";
import Button from "../../../../../../dumb/Button/C";
import Caption from '../../../../../../dumb/Caption/C';
import {apiAppList, apiAppSetDefault} from "../../../../../../../api/merchant/app";
import {TableMerchant} from "../../../../../../helpers/Table";
import {DisplayDataMerchant, DisplayIdMerchant} from '../../../../../../helpers/Display/DataDisplay';

import openPopupDeleteWidget from './openPopupDeleteWidget';
import openPopupCreateWindow from './openPopupCreateWidget';

const getRowsFromServer = () => {
  return apiAppList().then((res) => {
    return ({
      list: res.list,
      count: (res.list || []).length
    });
  })
}

export default (props) => {
  return (
    <>
      <Box width="100%" height="calc(100vh - 225px)" minHeight="500px" mt="2rem">
        <TableMerchant
          header={(update) => (
            <div className="layoutRow fhaB fvaC mb20">
              <Caption>Developer options</Caption>
              <Button
                className="w170 mv-5"
                onClick={() => {
                  openPopupCreateWindow({onUpdate: update})
                }}
              >
                New App
              </Button>
            </div>
          )}
          getDataFromServer={getRowsFromServer}
          columns={[
            {
              minWidth: 300,
              label: 'Web Site',
              dataKey: 'website',
              dataHandler: ({website}) => (
                <DisplayDataMerchant>
                  {website}
                </DisplayDataMerchant>
              )
            },
            {
              minWidth: 300,
              label: 'App ID',
              dataKey: 'id',
              dataHandler: ({id}) => (
                <DisplayIdMerchant>
                  {id}
                </DisplayIdMerchant>
              )
            },
            {
              minWidth: 300,
              label: 'API Secret',
              dataKey: 'secret',
              dataHandler: ({secret}) => (
                <DisplayIdMerchant>
                  {secret}
                </DisplayIdMerchant>
              )
            }
          ]}
          actions={(data, update) => ([
            {
              name: 'Set as default',
              onClick() {
                apiAppSetDefault({id: data.id}).then(update);
              },
            },
            {
              name: 'Notification settings',
              onClick() {
                props.emitInnerRoute({page: 'notifications', id: data.id});
              },
            },
            {
              name: (<div className="cF00">Delete</div>),
              onClick() {
                openPopupDeleteWidget(data, update);
              },
            },
          ])}
          disableFilters
        />
      </Box>
    </>
  );
};
